import { FormattedMessage } from "react-intl";
import type { FormSectionLabel } from "~components/Form/FormHelpSection";

const formFieldsDescription: Record<string, FormSectionLabel[]> = {
  basic: [
    {
      titleIntlKey: "name.local",
      descriptionIntlKey: { key: "form.help.local.name.item", item: <FormattedMessage id="league" /> },
    },
    {
      titleIntlKey: "name.latin",
      descriptionIntlKey: { key: "form.help.latin.name.item", item: <FormattedMessage id="league" /> },
    },
    {
      titleIntlKey: "abbreviationLocal",
      descriptionIntlKey: "form.help.local.abbreviation",
    },
    {
      titleIntlKey: "abbreviationLatin",
      descriptionIntlKey: "form.help.latin.abbreviation",
    },
    {
      titleIntlKey: "country",
      descriptionIntlKey: "form.help.league.country",
    },
    {
      titleIntlKey: "regionType",
      descriptionIntlKey: "form.help.league.region.type",
    },
  ],
};

export default formFieldsDescription;
